export const COM_LAT = 48.864716
export const COM_LNG = 2.349014
export const LEVEL_1 = 'level1'
export const LEVEL_2 = 'level2'

// damage types
export const ASSETS = 'ASSETS'
export const INTERIOR_PROPERTY = 'BIENS_IMMOBILIERS_INTERIEURS'
export const ROOF_ANGLE = 'ROOF_ANGLE'
export const FEATURE = 'FEATURE'
export const CPI = 'CPI'
export const MULTIDAMAGE = 'multidamage'
export const VITRE_INSERT = 'VITRE_INSERT'
export const OTHERS = 'AUTRES_SC'
export const AUTRES_GEN = 'AUTRES_GEN'
export const AUTRES_VALUE = 'AUTRES_VALUE'
export const GLASS_SURFACE_LEN = 'GLASS_SURFACE_LEN'
export const GLASS_SURFACE_WID = 'GLASS_SURFACE_WID'
export const EXT = 'EXT'
export const ROOM_SURFACE = 'ROOM_SURFACE'

// fnol component types
export const MESSAGE = 'message'
export const TEXT = 'text'
export const TEXTAREA = 'textarea'
export const DATE = 'date'
export const INTEGER = 'integer'
export const NUMBER = 'number'
export const FLOAT = 'float'
export const SELECT = 'select'
export const RADIO = 'radio'
export const CHECK = 'check'
export const MULTICHECK = 'multicheck'
export const SELFCARE = 'selfcare'
export const IMAGEBUTTON = 'image_button'

// form types
export const FORM_INPUTS_MOBILIER = 'formInputsMobilier'
export const FORM_UPTEC_FEATURE = 'uptecFeature'
export const FORM_UPTEC_CPI = 'uptecCpi'

// billma types
export const BILLMA_DOCUMENT_ICR_STATUS = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    VALID: 'VALID',
    ALERT: 'ALERT',
    DONE: 'DONE',
    ERROR: 'DONE'
}

export const BILLMA_DOCUMENTS_TYPES = {
    BUDGET: 'BUDGET',
    INVOICE: 'INVOICE'
}

// Keyboard keys
export const BACKSPACE = 8
export const LEFT_ARROW = 37
export const RIGHT_ARROW = 39
export const DELETE = 46